import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import classNames from "classnames";
import MuiPopover from "@mui/material/Popover";
export const Popover = props => {
  const {
    className,
    classes,
    ...otherProps
  } = props;
  return /*#__PURE__*/React.createElement(MuiPopover, _extends({
    className: "prmbl-popover-wrapper",
    classes: {
      ...classes,
      paper: classNames("prmbl-popover", className, classes?.paper)
    }
  }, otherProps));
};
export default Popover;